// import axios from 'axios'
import * as config from 'config'
import { useAuth0 } from 'libs/auth0-react'

const useChowlyLogger = () => {
  const { user } = useAuth0()

  const log = (message: string, messagePayload?: any) => {
    try{
    if(config.appSettings.isDevelopment) {
      console.log(message, messagePayload)
      return
    }
    if (config.chowlyLoggerApi.baseURL && config.chowlyLoggerApi.path) {
      fetch(`${config.chowlyLoggerApi.baseURL}${config.chowlyLoggerApi.path}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          message: message,
          message_payload: messagePayload,
          user: user?.email,
          timestamp: new Date().toISOString(),
          source: 'rcc'
        })
      })
      }
    } catch (error) {
      console.error('Error logging message:', error)
      return
    }
  }

  return { log }
}

export default useChowlyLogger
